import {Tile} from '../tile';
import {TileIcon} from '../tile-icon';
import {ColorOption} from '../appearance';

export type TileElemType =
  'Number' |
  'MultiChoice' |
  'Toggle' |
  'Folder' |
  'Minimal';

export interface TileElemOptions {
  tile: Tile;
  displayName?: string;
  displayIcon?: TileIcon;
  displayColor?: ColorOption;
  hideAlarmMenu?: boolean;
}

export interface TileElemOptionsWritable extends TileElemOptions {
  writable?: boolean;
}

export abstract class TileElemSetup {
  abstract readonly elemType: TileElemType;

  tile: Tile;
  displayName: string;
  displayIcon: TileIcon;
  displayColor: ColorOption;
  hideAlarmMenu: boolean;


  protected constructor(options: TileElemOptions) {
    this.tile = options.tile;
    this.displayName = options.displayName;
    this.displayIcon = options.displayIcon;
    this.displayColor = options.displayColor;
    this.hideAlarmMenu = !!options.hideAlarmMenu;
  }
}

/**
 *
 */
export class TileNumberElemSetup extends TileElemSetup {
  readonly elemType = 'Number';

  writable: boolean = false;


  constructor(options: TileElemOptionsWritable & {}) {
    super(options);
    this.writable = options.writable;
  }
}

/**
 *
 */
export class TileMultiChoiceElemSetup extends TileElemSetup {
  readonly elemType = 'MultiChoice';

  writable: boolean = false;


  constructor(options: TileElemOptionsWritable & {}) {
    super(options);
    this.writable = options.writable;
  }
}

/**
 *
 */
export class TileMinimalElemSetup extends TileElemSetup {
  readonly elemType = 'Minimal';

  constructor(options: TileElemOptionsWritable & {}) {
    super(options);
  }
}

/**
 *
 */
export class TileToggleElemSetup extends TileElemSetup {
  readonly elemType = 'Toggle';

  showToggle: boolean = false;
  showStateText: boolean = true;
  writable: boolean = false;


  constructor(options: TileElemOptionsWritable & {
    showToggle: boolean;
    showStateText: boolean;
  }) {
    super(options);
    this.showToggle = options.showToggle;
    this.showStateText = options.showStateText;
    this.writable = options.writable;
  }
}

export class TileFolderElemSetup extends TileElemSetup {
  readonly elemType = 'Folder';


  constructor(options: TileElemOptions) {
    super(options);
  }
}
